import { isLocalhost } from './General'

export const DevLog = (message?: any, ...optionalParams: any[]) => {
  if (isLocalhost()) {
    return console.log(message, ...optionalParams);
  }
}